import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App.vue';
import routes from './routes';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

library.add(faArrowLeft);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

const router = new VueRouter({ routes });

new Vue({
	router,
	render: h => h(App),
}).$mount('#app');
